import { render, staticRenderFns } from "./compFollowform.vue?vue&type=template&id=72e5b512&"
import script from "./compFollowform.vue?vue&type=script&lang=js&"
export * from "./compFollowform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports